export const name = 'viewerManagerVeloApi' as const

export const FilesChangedMiddlewareSymbol = Symbol('FilesChangedMiddleware')
